// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_faded_round_groove/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_faded_round_groove: ModuleSchema = {
  "id": "core_faded_round_groove",
  "uniqueId": "B3D_GRV05",
  "createdAt": "2026-10-10T15:43:48.712Z",
  "updatedAt": "2026-10-10T15:43:48.712Z",
  "label": "Faded Round Groove",
  "description": "Rãnh 1/2 đường tròn lõm chạy dọc, thu nhỏ/fade ở hai đầu.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "groove",
    "round",
    "fade"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "grooveCount",
      "label": "Number of Faded Grooves",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "endMargin",
      "label": "Groove End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "grooveWidth",
      "label": "Round Groove Width",
      "min": 0.4,
      "max": 12,
      "step": 0.1,
      "default": 2.4,
      "unit": "mm"
    },
    {
      "key": "grooveDepth",
      "label": "Groove Depth",
      "min": 0,
      "max": 10,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Faded Round Groove",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Faded Round Groove",
      "parts": [
        {
          "name": "Faded Round Groove",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Faded Round Groove",
      "groupId": 0
    }
  ]
};
